import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-view container pb-5" }
const _hoisted_2 = { class: "card p-2 d-flex flex-row flex-wrap" }
const _hoisted_3 = { class: "ms-2" }
const _hoisted_4 = {
  class: "alert alert-dismissible alert-info",
  role: "alert"
}
const _hoisted_5 = { class: "alert__icon mt-2" }
const _hoisted_6 = { class: "password-wrapper form-container mt-3" }
const _hoisted_7 = { class: "input-create-password form-item" }
const _hoisted_8 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_9 = { class: "input-confirm-password form-item" }
const _hoisted_10 = { class: "d-flex justify-content-end my-4 row p-2" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_DynamicForms = _resolveComponent("DynamicForms")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_ModalValidationBirdSpro = _resolveComponent("ModalValidationBirdSpro")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumbs),
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "h-medium" }, "Informe seus dados", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("p", null, "Confira seus dados antes de criar sua senha de emissão", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "fw-600 capiton" }, "Certificado Adquirido", -1)),
          _createTextVNode(": " + _toDisplayString(_ctx.getProduto.nome), 1)
        ])
      ]),
      (_openBlock(), _createBlock(_component_DynamicForms, {
        key: _ctx.dynamicCount,
        ref: "dynamicComponent",
        fields: _ctx.form.fields,
        onIsValid: _ctx.handleIsValid
      }, null, 8, ["fields", "onIsValid"])),
      _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Senha de emissão", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("p", null, "Agora você precisa criar sua senha de emissão", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Icon, { name: "lightbulb-on" })
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "alert__content" }, [
          _createElementVNode("div", { class: "text" }, [
            _createTextVNode(" A senha deve ter entre "),
            _createElementVNode("b", null, "8 e 12 caracteres"),
            _createTextVNode(", ter pelo menos uma letra "),
            _createElementVNode("b", null, "maiúscula"),
            _createTextVNode(", uma letra "),
            _createElementVNode("b", null, "minúscula"),
            _createTextVNode(" e "),
            _createElementVNode("b", null, "números"),
            _createTextVNode(". "),
            _createElementVNode("br"),
            _createElementVNode("b", null, "Guarde sua senha em um local seguro pois não será possível alterar.")
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Input, {
            modelValue: _ctx.model.password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.password) = $event)),
            label: "Senha",
            icon: "lock",
            "is-required": true,
            placeholder: "Digite a senha",
            type: "password"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              class: _normalizeClass(["circle", [
              _ctx.validation.minLength ? 'bg--success' : 'bg--grayscale-light',
            ]])
            }, " +8 ", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["mx-2 circle", [
              _ctx.validation.uppercase ? 'bg--success' : 'bg--grayscale-light',
            ]])
            }, " A ", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["circle", [
              _ctx.validation.lowercase ? 'bg--success' : 'bg--grayscale-light',
            ]])
            }, " a ", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["ms-2 circle", [
              _ctx.validation.hasNumber ? 'bg--success' : 'bg--grayscale-light',
            ]])
            }, " 123 ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Input, {
            modelValue: _ctx.model.confirmPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.confirmPassword) = $event)),
            label: "Confirmação de senha",
            icon: "lock",
            "is-required": true,
            placeholder: "Confirme a senha",
            type: "password",
            "error-log": _ctx.errorPassword
          }, null, 8, ["modelValue", "error-log"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: _normalizeClass(["col-sm-12 col-md-2 btn btn-primary", !_ctx.isValid || !_ctx.isValidPassword ? 'btn-secondary' : 'btn-primary']),
          type: "button",
          disabled: !_ctx.isValid || !_ctx.isValidPassword,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.finishJourney && _ctx.finishJourney(...args)))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "me-2" }, "Avançar", -1)),
          _createVNode(_component_Icon, { name: "arrow-right" })
        ], 10, _hoisted_11)
      ]),
      _createVNode(_component_Contact)
    ]),
    _createVNode(_component_ModalValidationBirdSpro, {
      ref: "modalValidationBirdSpro",
      hotreload: 
      () => {
        _ctx.dynamicCount++
      }
    
    }, null, 8, ["hotreload"])
  ], 64))
}